// Wird von mehreren Sections eingebunden. Ohne diese Abfrage wirft der Browser
// beim zweiten Einbinden "Identifier 'LazyVideo' has already been declared"
// und bricht das Skript ab - Videos weiter unten starten dann nicht mehr.
if (!customElements.get("fw-lazy-video")) {
  class LazyVideo extends HTMLElement {
    constructor() {
      super();
      const video = this.querySelector("video");
      if (!video) return;
      this.videoObserver = new IntersectionObserver(
        this.intersectionObserverHandler
      );
      this.videoObserver.observe(video);
    }

    intersectionObserverHandler(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play();
        } else {
          entry.target.pause();
        }
      });
    }
  }

  customElements.define("fw-lazy-video", LazyVideo);
}
